import React from "react";
import "../../styles/overlay.css";
function Loader(props) {
  return (
    <div
      className={props.translucent === true ? "overlay translucent" : "overlay"}
      style={props.customStyle != null ? props.customStyle : {}}
    >
      <div className="overlay__inner">
        <div className="overlay__content">
          <span className="spinner"></span>
        </div>
      </div>
    </div>
  );
}

export default Loader;
